import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2} from '@api'
import {Button, Menu, MenuDivider} from '@blueprintjs/core'
import {FormControlLabel, Tooltip} from '@material-ui/core'
import {AssortmentLayoutContextMenuItem, AssortmentLayoutContextMenuItemContents, useVipLocalStore, VipLocalStore, WorkspaceChooserAssortmentsMenuItem} from '@modules'
import {icons, StoresInstance, VipFlexLayoutTabStoreContext} from '@stores'
import {LabeledButton, PrimaryIconButton, SmallSwitch} from 'centric-ui-components'
import * as css from './SelectAssortmentToolbarButton.css'

/// region Store

export class SelectAssortmentToolbarButtonStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const SelectAssortmentToolbarButtonStoreContext = React.createContext<SelectAssortmentToolbarButtonStore>(null)
export const useSelectAssortmentToolbarButtonStore = () => React.useContext(SelectAssortmentToolbarButtonStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const SelectAssortmentToolbarButton = observer<MyProps>(function SelectAssortmentToolbarButton({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new SelectAssortmentToolbarButtonStore(stores, obsProps)),
    {strings, stores: {catalogTab}, catalog: {isShowingAssortment, assortments}} = store

  useEffect(() => store.registerEffects(), [])

  if (!catalogTab?.tab?.catalogRoot?.catalog?.canShowAssortment) return null

  return (
    <SelectAssortmentToolbarButtonStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        {assortments.assortments.length === 1 ?
         <FormControlLabel
           className={css.switchAndLabel}
           classes={{label: css.switchLabel}}
           label={strings.assortment}
           control={<SmallSwitch checked={assortments.selectedAssortment != null}
                                 onChange={() => assortments.selectedAssortment = assortments.selectedAssortment != null ? null : _.first(assortments.assortments)}
                                 color='secondary'
                                 size='small'/>} />
        : <Popover2
          interactionKind='click'
          position='bottom-right'
          content={<Menu>
            <WorkspaceChooserAssortmentsMenuItem catalogRootTab={catalogTab.tab.catalogRoot}/>
          </Menu>}
        >
          <LabeledButton
            label={strings.assortment}
            showEllipsis
            rightIcon='caret-down'
            text={assortments?.selectedAssortment ? assortments?.selectedAssortment.title : 'None'}/>
        </Popover2>}
      </div>
      {isShowingAssortment && <Popover2
        interactionKind='click'
        position='bottom'
        content={<Menu className={css.layoutMenu}>
          <AssortmentLayoutContextMenuItemContents />
        </Menu>}
        >
        <PrimaryIconButton icon={icons.assortmentLayout} />
      </Popover2>}
    </SelectAssortmentToolbarButtonStoreContext.Provider>)
})

//text={}

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/SelectAssortmentToolbarButton.tsx